import { delay } from "../../../AsyncUtils";

export class DelayWaiter {
    private readonly timer: ExponentialTimer;

    public static readonly DefaultDelays: number[] = [100, 200, 1000, 5000];
    public static readonly DefaultCountLimits: number[] = [10, 20, 60];

    public constructor(
        delays: number[] = DelayWaiter.DefaultDelays,
        countLimits: number[] = DelayWaiter.DefaultCountLimits
    ) {
        this.timer = new ExponentialTimer(delays, countLimits);
    }

    public async delay(): Promise<void> {
        await delay(this.timer.getNextTime());
    }

    public reset(): void {
        this.timer.reset();
    }
}

class ExponentialTimer {
    private readonly countLimits: number[];
    private readonly delays: number[];
    private count = 0;
    private currentDelayIndex = 0;
    private currentLimitIndex = 0;

    public constructor(delays: number[], countLimits: number[]) {
        this.delays = delays;
        this.countLimits = countLimits;
    }

    public reset(): void {
        this.count = 0;
        this.currentDelayIndex = 0;
        this.currentLimitIndex = 0;
    }

    public getNextTime(): number {
        const currentLimit = this.countLimits[this.currentLimitIndex];
        if (currentLimit === undefined) {
            throw new Error(`Limit in limits array with index ${this.currentLimitIndex} was undefined`);
        }

        if (++this.count > currentLimit) {
            if (this.currentDelayIndex < this.delays.length - 1) {
                this.currentDelayIndex++;
            }
            if (this.currentLimitIndex < this.countLimits.length - 1) {
                this.currentLimitIndex++;
            }
            this.count = 1;
        }
        const currentDelay = this.delays[this.currentDelayIndex];
        if (currentDelay === undefined) {
            throw new Error(`Delay in delays array with index ${this.currentDelayIndex} was undefined`);
        }
        return currentDelay;
    }
}
